import { useNotificationPrefsContextOptional } from "./NotificationPrefsContext";
import { useServerNotifications } from "./useServerNotifications";
import { useLeadsFollowUpNotifications } from "./useLeadsFollowUpNotifications";
import { useEffect } from "react";
import { useMessagesInboxRealtime } from "@/modules/messages/useMessagesInboxRealtime";
import { setNotificationHistory } from "./notificationHistory";
import { useViewAsCompanySession } from "@/modules/platform/platformApi";

/**
 * Notifications are created on the server (database triggers) and read
 * here: the bell list, sounds and desktop alerts come from one stream.
 * Must sit under NotificationPrefsProvider + MessagesQuickAccessProvider.
 * Renders nothing when prefs context is missing (avoids white-screen on remount/HMR).
 */
export const AppNotificationsLayer = () => {
  const prefs = useNotificationPrefsContextOptional();
  const { data: viewSession } = useViewAsCompanySession();
  if (!prefs) return null;
  // An operator viewing as a company is not one of its members: their own
  // (home) notifications must not show, and nothing should alert.
  if (viewSession) return <EmptyBellWhileViewing />;
  return <AppNotificationsSubscriptions />;
};

const EmptyBellWhileViewing = () => {
  useEffect(() => {
    setNotificationHistory([]);
  }, []);
  return null;
};

const AppNotificationsSubscriptions = () => {
  // Keeps the messages inbox live (unread counts, previews).
  useMessagesInboxRealtime(true);
  useServerNotifications();
  useLeadsFollowUpNotifications();
  return null;
};
